import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';

function featureContentSlider() {
  const carousel = new Swiper( ".featured-content-slider .swiper", {
      direction: "horizontal",
      loop: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      a11y: true,
      observeParents: true,
      slidesPerView: 1.1,
      spaceBetween: 16,
      keyboardControl: true,
      autoHeight: false,
      speed: 1800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      modules: [Navigation, Pagination, Autoplay],
      navigation: {
        nextEl: ".featured-content-slider .btn-next",
        prevEl: ".featured-content-slider .btn-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.1,
          spaceBetween: 16
        },
        // when window width is >= 640px
        768: {
          slidesPerView: 1.0001,
          spaceBetween: 32
        }
      }
    }
  );


}

function educationFeedSlider() {
    const feedSlider = new Swiper(
      ".education-feed .swiper",
      {
        direction: "horizontal",
        loop: false,
        centeredSlides: true,
        centeredSlidesBounds: true,
        a11y: true,
        observeParents: true,
        watchSlidesProgress: true,
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 16,
        keyboardControl: true,
        autoHeight: false,
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: ".education-feed .btn-next",
          prevEl: ".education-feed .btn-prev",
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1.2,
            spaceBetween: 16,
            centeredSlides: true,
            centeredSlidesBounds: true,
          },
          // when window width is >= 640px
          768: {
            slidesPerView: 3.2,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 4,
            centeredSlides: false,
            centeredSlidesBounds: false,
            spaceBetween: 32
          }
        }
      }
    );
  }



window.addEventListener("load", () => {
  featureContentSlider();
  educationFeedSlider();
});
